import { ReactElement } from "react";
import { TextArea, TextAreaProps } from "../inputs";
import {
  FormField,
  FormFieldControlProps,
  FormFieldContainerProps,
} from "./FormField";
import { FieldValues, FieldPath } from "react-hook-form";

interface Props<
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
>
  extends
    Omit<FormFieldControlProps<TFieldValues, TName>, "children">,
    Omit<FormFieldContainerProps, "children">,
    Omit<
      TextAreaProps,
      keyof FormFieldContainerProps | keyof FormFieldControlProps
    > {}

export function FormTextArea<
  T extends FieldValues,
  S extends FieldPath<T> = FieldPath<T>,
>(props: Props<T, S>): ReactElement {
  const {
    label,
    errorMessage,
    required,
    className,
    name,
    rules,
    shouldUnregister,
    defaultValue,
    control,
    ...rest
  } = props;

  return (
    <FormField.Control
      name={name}
      rules={rules}
      shouldUnregister={shouldUnregister}
      defaultValue={defaultValue}
      control={control}
    >
      {({ field }) => (
        <FormField.Container
          label={label}
          errorMessage={errorMessage}
          required={required}
          className={className}
        >
          <TextArea
            className="w-full"
            {...rest}
            {...field}
            hasError={errorMessage != null}
          />
        </FormField.Container>
      )}
    </FormField.Control>
  );
}
